import { updateDialog } from '@Containers/Dialogs/DialogsActions';

import { typeOfFilterByValueConfirmDialog } from './FilterByValueConfirmDialogConstants';

export function open(filterId) {
  return updateDialog({
    filterId,
    id: typeOfFilterByValueConfirmDialog,
    movable: false,
    size: 'md',
    dialogType: typeOfFilterByValueConfirmDialog,
  });
}
